import { ReactElement } from 'react';
import { ServiceDictionary } from '../../../../constants/service-dictionary.constants';
import { ITableLogsData } from '../logs-list.models';

export const ServiceCell = (data: ITableLogsData): ReactElement => (
  <div className="logs-table__service-cell">
    {ServiceDictionary[data.service] || data.service}
  </div>
);
